// select one [dev, staging, prod]
const EnvUsed = 'staging'
const Environtment = {
  api: {
    dev: 'https://appsensi-development-dot-appsensi-dev.df.r.appspot.com',
    staging: 'https://appsensi-staging-dot-appsensi-dev.df.r.appspot.com',
    prod: 'https://appsensi-kemang-dot-appsensi-dev.df.r.appspot.com',
  },
  report: {
    dev: 'https://reporting-development-dot-appsensi-dev.df.r.appspot.com',
    staging: 'https://reporting-staging-dot-appsensi-dev.df.r.appspot.com',
    prod: 'https://reporting-production-dot-appsensi-dev.df.r.appspot.com',
  },
  download: {
    dev: 'https://vpcreporting-fbilvsldzq-as.a.run.app',
    staging: 'https://reporting-staging-dot-appsensi-dev.df.r.appspot.com',
    prod: 'https://vpcreporting-fbilvsldzq-as.a.run.app',
  },
  v1: {
    dev: 'https://reporting-development-test-dot-appsensi-dev.df.r.appspot.com/v1',
    staging: 'https://reporting-staging-test-dot-appsensi-dev.df.r.appspot.com/v1',
    prod: 'https://reporting-production-test-dot-appsensi-dev.df.r.appspot.com/v1',
  },
  test: {
    dev: 'https://reporting-development-test-dot-appsensi-dev.df.r.appspot.com',
    staging: 'https://reporting-staging-test-dot-appsensi-dev.df.r.appspot.com',
    prod: 'https://reporting-production-test-dot-appsensi-dev.df.r.appspot.com',
  },
  firebase: {
    dev: {
      activities: 'activities_development',
      attendance: 'attendances_development',
      user: 'users_development',
      globalConfig: 'global_config_v2',
      userAnalytic: 'user_analytics_development',
      faceRecognition: 'face_recognition',
      prefixCompanyLogo: 'images/development/logo/',
      prefixNewsFeed: 'images/development/attachment/',
      prefixTaskAssigment: 'images/development/taskassigment/',
      prifixEmployee: 'files/development/attachment/' // +companyid + userid + 'Feature'
    },
    staging: {
      activities: 'activities_staging',
      attendance: 'attendances_staging',
      user: 'users_staging',
      globalConfig: 'global_config_v2_staging',
      userAnalytic: 'user_analytics_development',
      faceRecognition: 'face_recognition',
      prefixCompanyLogo: 'images/staging/logo/',
      prefixNewsFeed: 'images/staging/attachment/',
      prefixTaskAssigment: 'images/staging/taskassigment/',
      prifixEmployee: 'files/staging/attachment/' // +companyid + userid + 'Feature'
    },
    prod: {
      activities: 'activities',
      attendance: 'attendances',
      user: 'users',
      globalConfig: 'global_config_v2',
      userAnalytic: 'user_analytics',
      faceRecognition: 'face_recognition',
      prefixCompanyLogo: 'images/production/logo/',
      prefixNewsFeed: 'images/production/attachment/',
      prefixTaskAssigment: 'images/production/taskassigment/',
      prifixEmployee: 'files/production/attachment/' // +companyid + userid + 'Feature'
    },
  },
  storage: {
    dev: 'development',
    staging: 'staging',
    prod: 'production'
  },
  verihub: {
    url: 'https://api.verihubs.com',
    key: 'ukGhhmlRCUaGZD0M56/srmchcgzW18aw',
    id: '64d51245-2f61-4665-a8cc-bd5abf63783c',

  }
}

const costumHeader = (action, actionId) => {
  return { headers: { action, actionId } }
}

const env = {
  api: Environtment.api[EnvUsed],
  firebase: Environtment.firebase[EnvUsed],
  report: Environtment.report[EnvUsed],
  download: Environtment.download[EnvUsed],
  storage: Environtment.storage[EnvUsed],
  v1: Environtment.v1[EnvUsed],
  test: Environtment.test[EnvUsed],
  costumHeader,
  EnvUsed,
  verihub: Environtment.verihub
}

module.exports = env
